module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-slides-fill-f05b51e6.svg";